import { Link } from "react-router-dom";
import { ArrowUpRight, HelpCircle } from "lucide-react";
import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import FAQ from "@/data/faq";

const FAQSection = ({ limit = 6, showCta = true }) => {
    const items = FAQ.slice(0, limit);
    return (
        <section className="bg-[#FAFAFA] border-t border-black/10 py-16 lg:py-24" data-testid="faq-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                    <div className="lg:col-span-4">
                        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-4 flex items-center gap-2">
                            <HelpCircle className="h-3.5 w-3.5 text-[#E63946]" strokeWidth={2.6} />
                            FAQ
                        </div>
                        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[0.95]">
                            Vos questions,<br /><span className="text-[#E63946]">nos réponses.</span>
                        </h2>
                        <p className="mt-5 text-base text-zinc-600 leading-relaxed">
                            Tarifs, délais, garanties, paiement : les réponses aux questions les plus fréquentes
                            posées à Atelier Beauchamp.
                        </p>
                        {showCta && (
                            <Link
                                to="/faq"
                                data-testid="faq-section-see-all"
                                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.15em] hover:text-[#E63946] transition-colors border-b-2 border-[#E63946] pb-1"
                            >
                                Voir toutes les questions <ArrowUpRight className="h-4 w-4" />
                            </Link>
                        )}
                    </div>

                    <div className="lg:col-span-8">
                        <Accordion type="single" collapsible className="border-t border-b border-black/10">
                            {items.map((it, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className="border-b border-black/10 last:border-b-0 px-1"
                                    data-testid={`faq-item-${i}`}
                                >
                                    <AccordionTrigger className="text-left font-display font-bold uppercase text-sm sm:text-base tracking-tight py-5 hover:no-underline hover:text-[#E63946]">
                                        {it.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-sm sm:text-base text-zinc-600 leading-relaxed pb-5 pr-6">
                                        {it.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
